import { Injectable } from '@angular/core';
import { AppConstants_Design } from '../AppConstants_Design.enum';
import { AppConstants_settings } from '../AppConstants_Appsettings.enum';

@Injectable({
  providedIn: 'root',
})
export class TenantsService {
  Active_StaffId: any;
  constructor() {}
  getTenantFromSubdomain(): string {
    const compId = AppConstants_settings.COMPANY_ID || AppConstants_Design.COMPANYID || 'NS';
    return compId;
  }
}
